(ns io.daskul.webapp.widgets.form.value-with-unit-logic
  "A numeric field whose unit lives in a sibling field (#969) — a discount
   `value` that is ₱3,000.00 or 10% depending on `value-type`.

   Declared on the value field:

     :ui {:widget :value-with-unit
          :options {:unit-field :value-type
                    :units [{:value \"fixed-amount\" :display {:type :currency}}
                            {:value \"percentage\" :label \"%\"
                             :display {:type :percent}}]}}

   A currency unit declares no :label — its symbol comes from the money config,
   the same source the input's prefix comes from. The unit picker owns the
   glyph, so the input itself carries none.

   Pure: no React, no re-frame."
  (:require
   [io.daskul.webapp.format :as format]))

(defn- display-type [unit]
  (some-> (get-in unit [:display :type]) keyword))

(defn unit-choices
  "Picker choices, in declaration order — a map's order would be incidental."
  [units]
  (mapv (fn [{:keys [value label] :as unit}]
          {:value value
           :label (or label
                      (when (= :currency (display-type unit))
                        (:prefix (format/currency-input-props)))
                      value)})
        units))

(defn unit-props
  "Number-input props for the selected unit. Currency keeps its grouping and
   fixed decimals but not its prefix: the picker already shows the symbol."
  [unit]
  (if (= :currency (display-type unit))
    (dissoc (format/currency-input-props) :prefix)
    (format/number-input-props)))

(defn selected-unit
  "The unit the sibling field currently names. Falls back to the first declared
   unit so a record with no unit yet still renders."
  [units unit-value]
  (or (first (filter #(= unit-value (:value %)) units))
      (first units)))
